import LangLink from '../../../../components/common/LangLink';

const FounderCTA = ({ language }) => {
    const fr = language === 'fr';

    return (
        <section className="relative bg-white dark:bg-[#0f0f0f] text-gray-900 dark:text-white pt-0 pb-24 md:pt-[25px] md:pb-32">
            <div className="max-w-4xl mx-auto px-6 text-center">
                {/* Title */}
                <h2 className="font-['Rethink_Sans',sans-serif] font-normal text-gray-900 dark:text-white text-[42px] leading-[44px] tracking-[-1.5px] md:text-[64px] md:leading-[64px] md:tracking-[-2px] mb-0 pb-[70px] md:pb-[80px]">
                    {fr ? (
                        <>Créé par des pilotes,<br />pour des pilotes</>
                    ) : (
                        <>Created by pilots,<br />for pilots</>
                    )}
                </h2>

                {/* CTA */}
                <LangLink
                    to="/signup"
                    className="inline-flex items-center justify-center bg-[#0061fe] text-white font-['Manrope',sans-serif] font-semibold text-[13px] px-[26px] py-[18px] rounded-full hover:bg-[#0052db] active:scale-[0.98] transition-all shadow-lg shadow-[#0061fe]/20"
                >
                    {fr ? 'Commencer gratuitement' : 'Start for free'}
                </LangLink>
            </div>
        </section>
    );
};

export default FounderCTA;
